import { render } from "./UserProfileAllowedEnterprises.vue?vue&type=template&id=7bbbabf9&ts=true"
import script from "./UserProfileAllowedEnterprises.vue?vue&type=script&lang=ts"
export * from "./UserProfileAllowedEnterprises.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__